<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <v-icon>mdi-coins</v-icon>
            <h4 class="headline halfwhite-text ml-2">Send Ovations</h4>
          </v-card-title>
          <v-card color="white" class="rounded ml-3 mt-3">
            <v-card-text class="card-box">
              <v-card color="white" class="elevation-0 rounded">
                <v-card-text>
                  <div
                    v-if="
                      Number(
                        this.$store.state.userSelf.currentOrg.giveOvations
                      ) < 1
                    "
                  >
                    <v-alert :value="true" outline color="error" icon="error"
                      >Sorry, you don't currently have any Ovations to
                      Send</v-alert
                    >
                  </div>
                  <div v-else>
                    <v-form
                      v-model="FormValid"
                      v-on:submit.prevent="completeTransfer"
                      ref="form"
                    >
                      <v-flex>
                        <div class="d-flex">
                          <div
                            class="mr-4 font-weight-medium"
                            style="flex-grow: 0 !important"
                          >
                            <div class="mb-2">Available</div>
                            <div class="title text-xs-center">
                              {{
                                Number(
                                  $store.state.userSelf.currentOrg.giveOvations
                                ) > 0
                                  ? Number(
                                      $store.state.userSelf.currentOrg
                                        .giveOvations
                                    ).toLocaleString()
                                  : 0
                              }}
                            </div>
                          </div>
                          <div
                            class="mx-4"
                            style="flex-grow: 0 !important; width: 20%"
                          >
                            <div class="font-weight-medium">Enter Ovations</div>
                            <div>
                              <v-combobox
                                dense
                                flat
                                outline
                                single-line
                                class="mb-3"
                                type="number"
                                :min="0"
                                :max="
                                  $store.state.userSelf.currentOrg.giveOvations
                                "
                                :step="5"
                                v-model="ovationAmount"
                                :items="ovationItems"
                                :rules="amountRules"
                                label="Enter Ovations"
                              ></v-combobox>
                            </div>
                          </div>
                          <div
                            class="ml-4 font-weight-medium"
                            style="flex-grow: 0 !important"
                          >
                            <div class="mb-2">Balance</div>
                            <div class="title text-xs-center">
                              {{
                                Number(
                                  $store.state.userSelf.currentOrg.giveOvations
                                ) > 0
                                  ? Number(
                                      Number(
                                        $store.state.userSelf.currentOrg
                                          .giveOvations
                                      ) -
                                        Number(ovationAmount) *
                                          (orgRecipient.length === 0
                                            ? 1
                                            : orgRecipient.length)
                                    ).toLocaleString()
                                  : 0
                              }}
                            </div>
                          </div>
                        </div>
                      </v-flex>

                      <v-autocomplete
                        multiple
                        dense
                        flat
                        outline
                        single-line
                        chips
                        cache-items
                        v-model="orgRecipient"
                        :rules="orgRecipientRules"
                        :items="orgMembers"
                        :loading="loading"
                        :filter="customFilter"
                        label="Select member(s)"
                        placeholder="Select member(s) from your org"
                        hint="Filter list by typing member's email"
                        persistent-hint
                        color="primary"
                        background-color="#fafafa"
                        return-object
                      >
                        <template v-slot:progress>
                          <v-progress-linear
                            color="#d13b55"
                            height="2"
                            indeterminate
                          ></v-progress-linear>
                        </template>
                        <template slot="selection" slot-scope="data">
                          <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="removeRecipient(data.item)"
                          >
                            <v-avatar color="primary">
                              <img
                                v-if="(data.item || {}).isavatarlocal"
                                :src="(data.item || {}).avatarlocal"
                              />
                              <span v-else class="white--text">{{
                                data.item.firstname.charAt(0).toUpperCase() +
                                data.item.lastname.charAt(0).toUpperCase()
                              }}</span>
                            </v-avatar>
                            {{ data.item.firstname }}
                            {{ data.item.lastname }} ({{ data.item.orgName }})
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content
                              v-text="data.item"
                            ></v-list-tile-content>
                          </template>
                          <template v-else>
                            <v-list-tile-avatar color="primary">
                              <img
                                v-if="(data.item || {}).isavatarlocal"
                                :src="(data.item || {}).avatarlocal"
                              />
                              <span v-else class="white--text">{{
                                data.item.firstname.charAt(0).toUpperCase() +
                                data.item.lastname.charAt(0).toUpperCase()
                              }}</span>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title
                                >{{ data.item.firstname }}
                                {{ data.item.lastname }} ({{
                                  data.item.orgName
                                }})</v-list-tile-title
                              >
                              <v-list-tile-sub-title
                                v-html="data.item.email"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <v-flex mt-2 mb-2 v-if="orgRecipient">
                        Send
                        <span class="font-weight-medium">
                          {{ Number(ovationAmount) }}</span
                        >
                        Ovations from
                        <span class="blue-text font-weight-medium"
                          >{{
                            (this.$store.state.userSelf.profile || {}).firstname
                          }}
                          {{
                            (this.$store.state.userSelf.profile || {}).lastname
                          }}</span
                        >
                        to
                        <span class="orange-text font-weight-medium">{{
                          displayRecieversInfo(orgRecipient)
                        }}</span>
                      </v-flex>
                      <v-flex
                        mt-3
                        v-if="!$store.getters.enableRichTextInDashboard"
                      >
                        <v-textarea
                          flat
                          outline
                          single-line
                          v-model="message"
                          rows="3"
                          label="Message"
                          placeholder="Enter your message..."
                          :rules="messageRules"
                        ></v-textarea>
                      </v-flex>
                      <v-flex
                        mt-3
                        v-if="$store.getters.enableRichTextInDashboard"
                      >
                        <vue-editor
                          ref="editor"
                          class="rounded"
                          v-model="message"
                          placeholder="Enter text including animated GIFs, Emoticons & Stickers, click the image icon in the toolbar above..."
                          :editor-toolbar="customToolbar"
                          :editorOptions="editorSettings"
                          @selection-change="onSelectionChange"
                        />
                      </v-flex>
                      <v-flex mb-4>
                        <v-checkbox
                          color="#d13b55"
                          hint="If selected, then the amount of Ovations sent will not show up for any other user besides the person who sent it and the person who received it."
                          persistent-hint
                          v-model="isPrivate"
                          label="Make it Private"
                        ></v-checkbox>
                      </v-flex>
                      <v-btn
                        class="blue-bg btn-rounded-medium"
                        @click.prevent="completeTransfer"
                        :disabled="!FormValid"
                      >
                        Send Ovations
                      </v-btn>
                    </v-form>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <v-flex mt-4>
          <DashboardSidebar></DashboardSidebar>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-dialog v-model="showGiphyPicker" max-width="400" overlay>
        <GiphyPicker @onGifPicked="onGifPicked"></GiphyPicker>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";
import DashboardSidebar from "@/components/DashboardSidebar";
import GiphyPicker from "@/components/GiphyPicker";

import { VueEditor, Quill } from "vue2-editor";
window.Quill = Quill;
const ImageResize = require("quill-image-resize-module").default;
Quill.register("modules/imageResize", ImageResize);

export default {
  name: "GiveOvations",
  components: {
    DashboardSidebar,
    GiphyPicker,
    VueEditor,
  },
  data() {
    return {
      loading: true,
      orgRecipient: [],
      chipAmountStart: "10", // initial display (and after reset) of number of ovations to give
      ovationAmount: "0",
      message: "",
      orgMembers: [],
      FormValid: true,
      amountRules: [
        (v) => !!v || "Required",
        (v) => /^[0-9]+$/.test(v) || "Must be a number",
        (v) =>
          Number(v) <=
            Number(this.$store.state.userSelf.currentOrg.giveOvations) ||
          "Ovations amount exceeded. Available Ovations: " +
            this.$store.state.userSelf.currentOrg.giveOvations,
      ],
      orgRecipientRules: validationRules.requiredRules,
      messageRules: validationRules.addressRules,
      ovationItems: ["10", "25", "50", "75", "100"],
      isPrivate: false,
      showGiphyPicker: false,
      cursorLocation: { index: 0, length: 0 },
      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      editorSettings: {
        modules: {
          imageResize: {},
        },
      },
    };
  },
  computed: {},
  methods: {
    setChipAmountStart() {
      // if the user has less Ovations than the initial display amount of Ovations
      if (
        Number(this.$store.state.userSelf.currentOrg.giveOvations) <
        Number(this.chipAmountStart)
      ) {
        // display the total amount of Ovations that can be given
        this.ovationAmount = Number(
          this.$store.state.userSelf.currentOrg.giveOvations
        );
      }
      // otherwise display the chipAmountStart
      else {
        this.ovationAmount = this.chipAmountStart;
      }
    },
    completeTransfer() {
      // Validate ovations amount
      if (parseInt(this.ovationAmount) <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Please enter a valid number for Ovations",
          messageType: "warning",
        });
        return false;
      }

      if (this.orgRecipient.length <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Please select at least one member",
          messageType: "warning",
        });
        return false;
      }

      // Check if user is giving ovations to himself unless org admin [parent org-owner]
      for (let index = 0; index < this.orgRecipient.length; index++) {
        const recipientItem = this.orgRecipient[index];
        if (
          recipientItem.nameidentifier ===
            (this.$store.state.userSelf.profile || {}).nameidentifier &&
          recipientItem.subdomain ===
            this.$store.state.userSelf.currentOrg.org.subdomain &&
          !recipientItem.isOrgAdmin
        ) {
          this.$store.commit("replaceSnackbar", {
            message:
              "Sorry! You can't give ovations to yourself as an org owner",
            messageType: "warning",
          });
          return false;
        }
      }

      if (this.message === "" || this.message === undefined) {
        this.$store.commit("replaceSnackbar", {
          message: "Please enter a message",
          messageType: "warning",
        });
        return false;
      }

      const destinationData = this.orgRecipient.map(
        ({ nameidentifier, subdomain }) => ({
          nameidentifier,
          subdomain,
        })
      );

      // Check for user dupes, user in sub-domain treated as only one
      const userIds = destinationData.map((obj) => obj.nameidentifier);
      const userIdSet = new Set(userIds);
      const hasDuplicatesUserIds = userIdSet.size < destinationData.length;

      if (hasDuplicatesUserIds) {
        this.$store.commit("replaceSnackbar", {
          message: "Duplicate member(s) detected, please remove and try again",
          messageType: "warning",
        });
        return false;
      }

      // Disable form submission while async call takes place
      this.FormValid = false;
      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Sending Ovations...",
        messageType: "warning",
      });

      // create the object of information to post to the api
      const params = {
        subdomain: this.$store.state.userSelf.currentOrg.org.subdomain,
        destination: destinationData,
        amount: parseInt(this.ovationAmount),
        description: this.message,
        isPrivate: this.isPrivate,
      };

      // use api call to transfer funds
      axios
        .post(
          "/api/fund/givespendovations",
          params,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Allow form submission and reset form
          this.FormValid = true;
          this.$refs.form.reset();
          this.setChipAmountStart();
          this.message = "";
          this.orgRecipient = [];

          // Commit returned/received user info to global
          this.$store.commit("setUserSelf", response.data.self);

          if (response.data.failed || Number(response.data.failedCount) > 0) {
            this.$store.commit("replaceSnackbar", {
              message: `Could not send Ovations to ${response.data.failedCount} member(s).</br>Success: ${response.data.successCount}</br>Failed: ${response.data.failedCount}`,
              messageType: "warning",
            });
          } else {
            // Display Success message
            this.$store.commit("replaceSnackbar", {
              message: `Ovations have been sent to ${response.data.successCount} member(s).`,
            });
          }

          this.loading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Re-enable form for user to try again
          this.FormValid = true;
          this.loading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Failed to send ovations.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    customFilter(item, queryText, itemText) {
      const email = item.email.toLowerCase();
      const searchTerm = queryText.toLowerCase();

      return email.indexOf(searchTerm) > -1;
    },
    onSelectionChange(range) {
      if (range) this.cursorLocation = range;
    },
    onGifPicked(gifUrl) {
      if (gifUrl) {
        this.$refs.editor.quill.insertEmbed(
          this.cursorLocation == null ? 0 : this.cursorLocation.index,
          "image",
          gifUrl,
          Quill.sources.USER
        );
        this.showGiphyPicker = false;
      }
    },
    displayRecieversInfo(data) {
      if (!data || Array.isArray(data) === false) return "'NO MEMBER SELECTED'";
      if (data.length > 1) {
        return `${data.length} selected members`;
      } else if (data.length === 1) {
        const recipient = data[0];
        return `${recipient.firstname} ${recipient.lastname} (${recipient.orgName})`;
      } else {
        return "'NO MEMBER SELECTED'";
      }
    },
    removeRecipient(item) {
      let recipientIndex = this.orgRecipient.findIndex(
        (element) =>
          element.nameidentifier === item.nameidentifier &&
          element.subdomain === item.subdomain
      );
      if (recipientIndex >= 0) this.orgRecipient.splice(recipientIndex, 1);
    },
  },
  beforeMount() {
    this.setChipAmountStart();

    if (Number(this.$store.state.userSelf.currentOrg.giveOvations) > 0) {
      this.loading = true;
      var apiUrl = "/api/org/member/all/1";
      axios
        .get(apiUrl, this.$store.state.axiosConfig)
        .then((response) => {
          this.orgMembers = response.data;
          this.loading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Getting organization members.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });

          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.$refs.editor && this.$refs.editor.quill) {
      this.$refs.editor.quill.getModule("toolbar").addHandler("image", () => {
        this.showGiphyPicker = true;
        this.cursorLocation = this.$refs.editor.quill.getSelection();
      });
    }
  },
};
</script>
